// Centroïdes approximatifs des départements français (préfectures).
// Sources : coordonnées publiques des préfectures (IGN / OpenStreetMap).
// Utilisées uniquement pour positionner des markers sur la carte France stylisée.
// Ne sont PAS utilisées pour des calculs métier.

export interface DeptCoord {
  code: string
  nom: string
  lat: number
  lon: number
}

export const DEPARTEMENTS_FR: DeptCoord[] = [
  { code: '01', nom: 'Ain',                  lat: 46.202, lon: 5.228 },
  { code: '02', nom: 'Aisne',                lat: 49.564, lon: 3.624 },
  { code: '03', nom: 'Allier',               lat: 46.565, lon: 3.332 },
  { code: '04', nom: 'Alpes-de-Haute-Provence', lat: 44.098, lon: 6.235 },
  { code: '05', nom: 'Hautes-Alpes',         lat: 44.559, lon: 6.079 },
  { code: '06', nom: 'Alpes-Maritimes',      lat: 43.702, lon: 7.268 },
  { code: '07', nom: 'Ardèche',              lat: 44.733, lon: 4.601 },
  { code: '08', nom: 'Ardennes',             lat: 49.771, lon: 4.720 },
  { code: '09', nom: 'Ariège',               lat: 42.964, lon: 1.604 },
  { code: '10', nom: 'Aube',                 lat: 48.297, lon: 4.074 },
  { code: '11', nom: 'Aude',                 lat: 43.213, lon: 2.349 },
  { code: '12', nom: 'Aveyron',              lat: 44.349, lon: 2.575 },
  { code: '13', nom: 'Bouches-du-Rhône',     lat: 43.297, lon: 5.381 },
  { code: '14', nom: 'Calvados',             lat: 49.183, lon: -0.370 },
  { code: '15', nom: 'Cantal',               lat: 44.927, lon: 2.447 },
  { code: '16', nom: 'Charente',             lat: 45.650, lon: 0.159 },
  { code: '17', nom: 'Charente-Maritime',    lat: 46.159, lon: -1.152 },
  { code: '18', nom: 'Cher',                 lat: 47.081, lon: 2.398 },
  { code: '19', nom: 'Corrèze',              lat: 45.266, lon: 1.770 },
  { code: '21', nom: "Côte-d'Or",            lat: 47.322, lon: 5.041 },
  { code: '22', nom: "Côtes-d'Armor",        lat: 48.514, lon: -2.765 },
  { code: '23', nom: 'Creuse',               lat: 46.170, lon: 1.871 },
  { code: '24', nom: 'Dordogne',             lat: 45.184, lon: 0.721 },
  { code: '25', nom: 'Doubs',                lat: 47.238, lon: 6.024 },
  { code: '26', nom: 'Drôme',                lat: 44.933, lon: 4.892 },
  { code: '27', nom: 'Eure',                 lat: 49.024, lon: 1.151 },
  { code: '28', nom: 'Eure-et-Loir',         lat: 48.444, lon: 1.489 },
  { code: '29', nom: 'Finistère',            lat: 47.998, lon: -4.098 },
  { code: '2A', nom: 'Corse-du-Sud',         lat: 41.927, lon: 8.735 },
  { code: '2B', nom: 'Haute-Corse',          lat: 42.696, lon: 9.450 },
  { code: '30', nom: 'Gard',                 lat: 43.836, lon: 4.360 },
  { code: '31', nom: 'Haute-Garonne',        lat: 43.604, lon: 1.444 },
  { code: '32', nom: 'Gers',                 lat: 43.647, lon: 0.585 },
  { code: '33', nom: 'Gironde',              lat: 44.837, lon: -0.579 },
  { code: '34', nom: 'Hérault',              lat: 43.611, lon: 3.877 },
  { code: '35', nom: 'Ille-et-Vilaine',      lat: 48.117, lon: -1.677 },
  { code: '36', nom: 'Indre',                lat: 46.811, lon: 1.691 },
  { code: '37', nom: 'Indre-et-Loire',       lat: 47.394, lon: 0.685 },
  { code: '38', nom: 'Isère',                lat: 45.188, lon: 5.724 },
  { code: '39', nom: 'Jura',                 lat: 46.675, lon: 5.554 },
  { code: '40', nom: 'Landes',               lat: 43.891, lon: -0.501 },
  { code: '41', nom: 'Loir-et-Cher',         lat: 47.586, lon: 1.335 },
  { code: '42', nom: 'Loire',                lat: 45.440, lon: 4.387 },
  { code: '43', nom: 'Haute-Loire',          lat: 45.043, lon: 3.885 },
  { code: '44', nom: 'Loire-Atlantique',     lat: 47.218, lon: -1.554 },
  { code: '45', nom: 'Loiret',               lat: 47.903, lon: 1.910 },
  { code: '46', nom: 'Lot',                  lat: 44.447, lon: 1.441 },
  { code: '47', nom: 'Lot-et-Garonne',       lat: 44.204, lon: 0.621 },
  { code: '48', nom: 'Lozère',               lat: 44.517, lon: 3.500 },
  { code: '49', nom: 'Maine-et-Loire',       lat: 47.471, lon: -0.553 },
  { code: '50', nom: 'Manche',               lat: 49.116, lon: -1.089 },
  { code: '51', nom: 'Marne',                lat: 48.957, lon: 4.363 },
  { code: '52', nom: 'Haute-Marne',          lat: 48.112, lon: 5.139 },
  { code: '53', nom: 'Mayenne',              lat: 48.073, lon: -0.770 },
  { code: '54', nom: 'Meurthe-et-Moselle',   lat: 48.692, lon: 6.184 },
  { code: '55', nom: 'Meuse',                lat: 48.774, lon: 5.164 },
  { code: '56', nom: 'Morbihan',             lat: 47.658, lon: -2.760 },
  { code: '57', nom: 'Moselle',              lat: 49.120, lon: 6.176 },
  { code: '58', nom: 'Nièvre',               lat: 46.990, lon: 3.163 },
  { code: '59', nom: 'Nord',                 lat: 50.629, lon: 3.057 },
  { code: '60', nom: 'Oise',                 lat: 49.431, lon: 2.080 },
  { code: '61', nom: 'Orne',                 lat: 48.432, lon: 0.092 },
  { code: '62', nom: 'Pas-de-Calais',        lat: 50.291, lon: 2.778 },
  { code: '63', nom: 'Puy-de-Dôme',          lat: 45.778, lon: 3.087 },
  { code: '64', nom: 'Pyrénées-Atlantiques', lat: 43.296, lon: -0.370 },
  { code: '65', nom: 'Hautes-Pyrénées',      lat: 43.232, lon: 0.078 },
  { code: '66', nom: 'Pyrénées-Orientales',  lat: 42.697, lon: 2.895 },
  { code: '67', nom: 'Bas-Rhin',             lat: 48.584, lon: 7.748 },
  { code: '68', nom: 'Haut-Rhin',            lat: 47.748, lon: 7.336 },
  { code: '69', nom: 'Rhône',                lat: 45.764, lon: 4.835 },
  { code: '70', nom: 'Haute-Saône',          lat: 47.625, lon: 6.154 },
  { code: '71', nom: 'Saône-et-Loire',       lat: 46.306, lon: 4.828 },
  { code: '72', nom: 'Sarthe',               lat: 48.006, lon: 0.198 },
  { code: '73', nom: 'Savoie',               lat: 45.564, lon: 5.917 },
  { code: '74', nom: 'Haute-Savoie',         lat: 45.899, lon: 6.129 },
  { code: '75', nom: 'Paris',                lat: 48.856, lon: 2.352 },
  { code: '76', nom: 'Seine-Maritime',       lat: 49.443, lon: 1.099 },
  { code: '77', nom: 'Seine-et-Marne',       lat: 48.540, lon: 2.660 },
  { code: '78', nom: 'Yvelines',             lat: 48.802, lon: 2.130 },
  { code: '79', nom: 'Deux-Sèvres',          lat: 46.324, lon: -0.464 },
  { code: '80', nom: 'Somme',                lat: 49.894, lon: 2.296 },
  { code: '81', nom: 'Tarn',                 lat: 43.928, lon: 2.148 },
  { code: '82', nom: 'Tarn-et-Garonne',      lat: 44.016, lon: 1.354 },
  { code: '83', nom: 'Var',                  lat: 43.466, lon: 6.236 },
  { code: '84', nom: 'Vaucluse',             lat: 43.948, lon: 4.806 },
  { code: '85', nom: 'Vendée',               lat: 46.670, lon: -1.427 },
  { code: '86', nom: 'Vienne',               lat: 46.580, lon: 0.340 },
  { code: '87', nom: 'Haute-Vienne',         lat: 45.834, lon: 1.260 },
  { code: '88', nom: 'Vosges',               lat: 48.172, lon: 6.450 },
  { code: '89', nom: 'Yonne',                lat: 47.798, lon: 3.573 },
  { code: '90', nom: 'Territoire-de-Belfort', lat: 47.638, lon: 6.863 },
  { code: '91', nom: 'Essonne',              lat: 48.630, lon: 2.441 },
  { code: '92', nom: 'Hauts-de-Seine',       lat: 48.849, lon: 2.216 },
  { code: '93', nom: 'Seine-Saint-Denis',    lat: 48.914, lon: 2.454 },
  { code: '94', nom: 'Val-de-Marne',         lat: 48.786, lon: 2.456 },
  { code: '95', nom: "Val-d'Oise",           lat: 49.043, lon: 2.044 },
]

export const DEPT_BY_CODE: Record<string, DeptCoord> = Object.fromEntries(
  DEPARTEMENTS_FR.map((d) => [d.code, d]),
)

// Projection simple (equirectangulaire) pour la France métropolitaine,
// calibrée pour un viewBox SVG 0 0 800 900.
export const FR_BOUNDS = {
  minLon: -5.2,
  maxLon: 9.7,
  minLat: 41.3,
  maxLat: 51.2,
}

export function projectToSVG(
  lat: number,
  lon: number,
  width = 800,
  height = 900,
): { x: number; y: number } {
  const { minLon, maxLon, minLat, maxLat } = FR_BOUNDS
  const x = ((lon - minLon) / (maxLon - minLon)) * width
  const y = ((maxLat - lat) / (maxLat - minLat)) * height
  return { x, y }
}
